/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBackground = createReactComponent("outline", "background", "IconBackground", [["path", { "d": "M4 8l4 -4", "key": "svg-0" }], ["path", { "d": "M14 4l-10 10", "key": "svg-1" }], ["path", { "d": "M4 20l16 -16", "key": "svg-2" }], ["path", { "d": "M20 10l-10 10", "key": "svg-3" }], ["path", { "d": "M20 16l-4 4", "key": "svg-4" }]]);

export { IconBackground as default };
//# sourceMappingURL=IconBackground.mjs.map
